import React from 'react';
import { Membership } from 'works/graphql/works-membership';
import { MemberViewDrawerFacilities } from './member-view-drawer-facilities';

type ContentProps = {
  membership: Membership | undefined;
};

export function MemberViewLocations({ membership }: ContentProps) {
  const organizationUnits = membership?.organizationUnitsActive;
  const showFacilities = organizationUnits && organizationUnits?.length > 0;

  return (
    <>
      {showFacilities && (
        <MemberViewDrawerFacilities
          organizationBusinesses={membership.organizationBusinessesActive}
          organizationUnits={membership.organizationUnitsActive}
        />
      )}
    </>
  );
}
